import React, { useContext, useState } from "react";
import { ProductsContext } from "../../../utils/stateHandlers/contexts";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import MenuItem from "@mui/material/MenuItem";
import Modal from "../../diamonds/controls/Modal";
import _ from "lodash";

export default function TreatmentField(props) {
  const { productState, productDispatch } = useContext(ProductsContext);
  const { style, productInfo, priceLoaded } = productState;
  const [showHelp, setShowHelp] = useState(false);
  const [helpTitle, setHelpTitle] = useState("");
  const [helpText, setHelpText] = useState();
  const [localTreatment, setLocalTreatment] = useState("None");
  const field = props.field;

  function updateTreatments(treatmentType, event) {
    setLocalTreatment(event.target.value);
    const treatmentToUpdate = _.find(
      productInfo.treatments,
      function (treatment) {
        return treatment.name === treatmentType;
      }
    );
    if (treatmentToUpdate && event.target.value === "None") {
      const removeTreatment = _.filter(
        productInfo.treatments,
        function (treatment) {
          return treatment.name !== treatmentToUpdate.name;
        }
      );
      productDispatch({
        type: "updateTreatments",
        payload: removeTreatment === [] ? "" : removeTreatment,
      });
    } else if (treatmentToUpdate && event.target.value !== "None") {
      treatmentToUpdate.value = event.target.value;
      productDispatch({
        type: "updateTreatments",
        payload: productInfo.treatments,
      });
    } else {
      productDispatch({
        type: "updateTreatments",
        payload: [
          ...productInfo.treatments,
          { name: treatmentType, value: event.target.value },
        ],
      });
    }
  }

  // useEffect(() => {
  //   if (clear) {
  //     productDispatch({ type: "setClear", payload: false });
  //     setLocalTreatment("None");
  //     console.log("treatments clear function");
  //     productDispatch({
  //       type: "updateTreatments",
  //       payload: [],
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [clear]);

  return (
    <span key={field.label}>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        {field.label}
        {props.isMill && style === "FS" && field.type === "FORM" && (
          <InfoIcon
            sx={{ marginLeft: "0.5rem" }}
            color="primary"
            onClick={() => {
              setShowHelp(true);
              setHelpTitle("Flat Sheet Finished Form");
              setHelpText(
                "Copy here about Exact Cuts and Slit Strip - to come from Stewart Or, this might just be deleted. TBD."
              );
            }}
          />
        )}
        {props.isMill && style === "FS" && field.type === "TEMPER" && (
          <InfoIcon
            sx={{ marginLeft: "0.5rem" }}
            color="primary"
            onClick={() => {
              setShowHelp(true);
              setHelpTitle("Flat Sheet Temper");
              setHelpText(
                "Standard temper gold sheet is annealed at approximately 0.002” - 0.010” before the final thickness is reached, depending on the thickness of the sheet. This is our standard temper which we provide unless otherwise requested. Soft temper gold sheet is annealed after the final thickness is reached, making it dead soft. We will provide this temper upon request. Hard temper gold sheet is annealed approximately 0.004” - 0.015” before the final thickness is reached. We stock sterling silver sheet in our standard temper and will provide hard temper sheet for an additional $10.50, upon request."
              );
            }}
          />
        )}
      </Typography>
      <Select
        key={field.name}
        value={localTreatment === null ? field.default : localTreatment}
        size="small"
        sx={{ width: "100%" }}
        disabled={!priceLoaded}
        onChange={(e) => {
          updateTreatments(field.type, e);
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              border: "1px solid #939598",
              borderRadius: "0",
            },
          },
        }}
      >
        <MenuItem value="None">
          <em>Select...</em>
        </MenuItem>
        {field.values.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <Modal
        title={helpTitle}
        onClose={() => setShowHelp(false)}
        show={showHelp}
      >
        {helpText}
      </Modal>
    </span>
  );
}
